import CategoriesSection from "./CategoriesSection"
import ExamHeroSection from "./ExamHeroSection"
import UpcomingExamSection from "./UpcomingExamSection"
import MockTestSection from "./MockTestSection"

const ExamPrep = () => {
  return (
    <div>
      <ExamHeroSection />
      <CategoriesSection />
      <UpcomingExamSection />
      <MockTestSection />
    </div>
  )
}

export default ExamPrep;
